import Rebalance from '@/modules/rebalance'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/rebalance/')({
  component: Rebalance,
})

